<template>
  <v-layout fill-height column id="tutorialGuide06">
    <v-main class="page-suitcase page-suitcase-main tutorial-guide-content">
      <v-container fluid>
        <div class="page-suitcase-top">
          <v-spacer/>
          <v-tooltip attach
                     left
                     max-width="100vw"
                     class="tooltip-coach"
                     :value="tooltipActive">
            <template v-slot:activator="{ attrs }">
              <v-btn rounded small depressed
                     :color="isSamsungFire ? 'primary' : ''"
                     :text="!isSamsungFire"
                     class="btn-suitcase-info"
                     v-bind="attrs"
                     @click.prevent>
                <i class="icon-info"></i>여행 안내소
              </v-btn>
            </template>
            <span class="tooltip-text text-end" id="tooltipSuitcaseInfo">1:1문의, 알림 설정 등</span>
          </v-tooltip>
        </div>
        <div class="my-info">
          <v-tooltip attach
                     top
                     max-width="100vw"
                     class="tooltip-coach"
                     :value="tooltipActive">
            <template v-slot:activator="{ attrs }">
              <div class="my-info-avatar">
                <v-avatar width="100%" height="100%">
                  <img :src="require('@/assets/images/avatar/profile_img_00.jpg')" />
                </v-avatar>
              </div>
              <v-btn text x-large
                     class="btn-edit-my-info"
                     v-bind="attrs"
                     @click.prevent
              >
                <div class="text-ellipsis">홍길동</div>
              </v-btn>
            </template>
            <span class="tooltip-text" id="tooltipEditMyInfo">내 정보보기 및<br />프로필 설정이 가능해요.</span>
          </v-tooltip>

          <v-tooltip attach
                     :right="isSamsungFire"
                     :bottom="!isSamsungFire"
                     max-width="100vw"
                     class="tooltip-coach"
                     :value="tooltipActive">
            <template v-slot:activator="{ attrs }">
              <div class="my-info-buttons"
                   v-bind="attrs"
              >
                <v-btn rounded small depressed
                       :color="isSamsungFire ? 'gray-100' : ''"
                       :text="!isSamsungFire"
                       class="btn-suitcase-my-ticket"
                       @click.prevent>
                  <i></i>내 티켓
                </v-btn>
                <v-btn v-if="!isSamsungFire"
                       rounded small depressed text
                       class="btn-suitcase-my-coin"
                       @click.prevent>
                  <i></i>15P
                </v-btn>
              </div>
            </template>
            <span class="tooltip-text" id="tooltipMyInfoButtons">
              {{ isSamsungFire ? '보유하고 있는 티켓 현황을 확인해요.' : '보유하고 있는 티켓 및 코인현황을 확인해요.' }}
            </span>
          </v-tooltip>
        </div>

        <div class="my-travelling-box">
          <div class="my-travelling-info">
            <div v-if="!isSamsungFire" class="my-travelling-img">
              <v-avatar width="100%" height="100%">
                <img :src="getImage('background/space/thumb_ezn.jpg')" />
              </v-avatar>
            </div>
            <p class="text">
              <b>45일째 여행중</b><br/>
              <span v-if="isSamsungFire">집중관리 | </span>2023.06.14 ~  2023.09.09
            </p>
          </div>
        </div>

<!--        <br>-->
<!--        <p class="text-center" v-if="isSamsungFire">-->
<!--          <v-chip small color="primaryLight" text-color="primary" class="py-2">-->
<!--            서비스 이용기간-->
<!--            <v-divider vertical class="mx-2" />-->
<!--            <b>2020.11.24 ~ 2023.11.23</b>-->
<!--          </v-chip>-->
<!--        </p>-->

        <!-- 나의 마음나무 -->
        <article class="page-suitcase-box">
          <v-tooltip attach
                     bottom
                     class="tooltip-coach"
                     :value="tooltipActive">
            <template v-slot:activator="{ attrs }">
              <header class="box-header"
                      v-bind="attrs"
              >
                <h2 class="box-title">나의 마음나무</h2>
              </header>
            </template>
            <span class="tooltip-text text-center" id="tooltipScroll">
              <v-icon large color="white" class="mb-3">mdi-pan-vertical</v-icon><br />
              아래로 스크롤하여<br />내 뱃지, 마음날씨, 마음노트도 확인 가능해요.
            </span>
          </v-tooltip>
          <div class="my-tree-box">
            <div class="my-tree-info">
              <img :src="require('@/assets/images/weather/ic_weather01.svg')" height="52" class="ml-22">
              <img :src="require('@/assets/images/tree/ic_tree21.svg')" height="136">
            </div>
            <v-tooltip attach
                       top
                       max-width="100vw"
                       class="tooltip-coach"
                       :value="tooltipActive">
              <template v-slot:activator="{ attrs }">
                <v-btn depressed rounded
                       color="primary"
                       class="btn-start btn-my-tree-info"
                       v-bind="attrs"
                       @click.prevent>검사 결과 보기</v-btn>
              </template>
              <span class="tooltip-text" id="tooltipMyTreeInfo">여행지원서의 사전/사후결과를 확인할 수 있어요.</span>
            </v-tooltip>
          </div>
        </article>
        <!-- //나의 마음나무 -->

      </v-container>
      <slot name="bottomMenu" />
    </v-main>
    <slot />
  </v-layout>
</template>

<script>
import {mixinAuth} from '@/mixins'
export default {
  name: 'TutorialSlide6',
  components: {},
  mixins: [mixinAuth],
  props: ['props'],
  data: () => ({
    tooltipActive: false
  }),
  mounted () {
    setTimeout(function () {
      this.tooltipActive = true
    }.bind(this), 300)
  }
}
</script>
<!--<style lang="scss" src="@/assets/sass/page/_tutorial.scss" scoped></style>-->
<style lang="scss" scoped>
.tutorial-guide-content::v-deep {
  flex: 1 1 auto;
  overflow: hidden;
  .container {
    box-sizing: border-box;
  }
  .my-info {
    overflow: visible;
  }
  .my-travelling-info {
    .my-travelling-img {
      z-index: 0;
    }
  }
  .btn-suitcase-info {
    z-index: 8;
  }
  .btn-edit-my-info {
    display: flex;
    min-height: 40px;
    padding-left: 10px !important;
    margin-left: -10px;
    border-radius: 50em;
    z-index: 8;
    background-color: #fff;
    &:after {
      content: "";
      display: inline-block;
      width: 10px;
    }
  }
  .btn-my-tree-info {
    z-index: 8;
  }
}
html:not([data-theme="samsungfire"]) {
  .tooltip-coach {
    #tooltipSuitcaseInfo {
      left: 130px;
      top: 30px;
      &:after {
        transform: scaleX(-1) rotate(140deg);
        left: -30px;
        top: -25px;
        width: 29px;
        height: 29px;
        background-position: left center;
        background-image: var(--coach-mark-arrow-03);
      }
    }
    #tooltipEditMyInfo {
      left: 50px;
      bottom: 50px;
      &:after {
        transform: scaleY(-1);
        width: 56px;
        height: 55px;
        left: -60px;
        top: 10px;
        background-image: var(--coach-mark-arrow-02);
      }
    }
    #tooltipMyInfoButtons {
      left: -15px;
      &:after {
        transform: scaleX(-1) rotate(90deg);
        left: 5px;
        top: -35px;
        width: 29px;
        height: 29px;
        background-position: left center;
        background-image: var(--coach-mark-arrow-03);
      }
    }
    #tooltipMyTreeInfo {
      top: -10px;
      &:after {
        left: -25px;
        top: 5px;
        width: 19px;
        height: 29px;
        background-position: left center;
        background-image: var(--coach-mark-arrow-03);
      }
    }
  }
  .tutorial-guide-content {
    .btn-suitcase-info {
      padding-left: 10px !important;
      padding-right: 10px !important;
      margin-right: -10px;
      border-radius: 50rem !important;
      background-color: #fff;
    }
    .my-info-buttons {
      z-index: 8;
      padding: 3px 10px 5px;
      margin: 3px -10px;
      border-radius: 50rem;
      background-color: #fff;
      .v-btn:not(.v-btn--round).v-size--small {
        height: unset;
      }
    }
  }
}
[data-theme="samsungfire"] {
  .tooltip-coach {
    #tooltipSuitcaseInfo {
      left: 19px;
      top: -19px;
      &:after {
        transform: scale(-1) rotate(55deg);
        left: 66px;
        top: 9px;
        width: 29px;
        height: 29px;
        background-position: left center;
        background-image: var(--coach-mark-arrow-03);
      }
    }
    #tooltipEditMyInfo {
      left: 30px;
      bottom: 50px;
      &:after {
        width: 56px;
        height: 55px;
        left: -60px;
        top: 10px;
        background-image: var(--coach-mark-arrow-02);
      }
    }
    #tooltipMyInfoButtons {
      left: 0;
      top: 35px;
      &:after {
        transform: scaleX(-1) rotate(90deg);
        left: 22px;
        top: -35px;
        width: 29px;
        height: 29px;
        background-position: left center;
        background-image: var(--coach-mark-arrow-03);
      }
    }
    #tooltipMyTreeInfo {
      left: 30px;
      &:after {
        width: 56px;
        height: 55px;
        left: -60px;
        top: 0;
        background-image: var(--coach-mark-arrow-02);
      }
    }
  }
  .tutorial-guide-content {
    .my-info-buttons {
      flex-grow: 1;
      text-align: right;
    }
    .btn-suitcase-my-ticket {
      z-index: 8;
    }
  }
}
</style>
